import styled from 'styled-components';

const YouTubeContainer = styled.div`
  width: 784px;
  max-width: 100%;
  margin: 40px auto;

  .inner-container {
    position: relative;
    padding-top: 56.25%;

    .player {
      position: absolute;
      top: 0;
      left: 0;
    }

    .wistia-video--play-button {
      pointer-events: none;
      left: calc(50% - 55px);
      bottom: calc(50% - 55px);
    }
  }
`;

export { YouTubeContainer };
